import { Box } from '@mui/material'
import { brandColors, brandFonts } from '../styled/brand'
import LegalPage, {
  LegalSection,
  LegalCallout,
} from '../components/brand/LegalPage'

const meta = (
  <>
    <Box
      component="p"
      sx={{
        margin: '16px 0 0',
        fontFamily: brandFonts.heading,
        fontWeight: 600,
        fontSize: 16,
        color: brandColors.coralText,
      }}
    >
      Android version
    </Box>
    <Box
      component="p"
      sx={{
        margin: '20px 0 0',
        fontSize: 16,
        fontWeight: 500,
        color: brandColors.textMuted,
      }}
    >
      Last updated: October 4, 2024
    </Box>
  </>
)

const Eula = () => (
  <LegalPage title="End-User License Agreement" meta={meta}>
    <LegalCallout>
      <p>
        <strong>Note:</strong> This EULA applies only to the{' '}
        <strong>Android</strong> version of the <strong>Last Seen</strong> app
        available on the <strong>Google Play Store</strong>. If you are using the{' '}
        <strong>iOS</strong> version, your use is governed by the{' '}
        <a href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/">
          <strong>Apple Standard EULA</strong>
        </a>
        .
      </p>
    </LegalCallout>

    <LegalSection>
      <p>
        This End-User License Agreement ("Agreement") is a legal contract between
        you ("User" or "you") and 15156215 Canada Inc., doing business as
        Apperytime ("Company," "we," or "us"), concerning your use of the Last
        Seen mobile application ("App") available on the Google Play Store.
      </p>
      <p>
        By downloading, installing, or using the App, you agree to be bound by
        the terms of this Agreement. If you do not agree to these terms, do not
        use the App.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>1. License Grant</h3>
      <p>
        We grant you a non-exclusive, non-transferable, revocable license to use
        the App for your personal, non-commercial purposes on any compatible
        Android device that you own or control, in accordance with this
        Agreement.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>2. Restrictions on Use</h3>
      <p>
        You agree <strong>not</strong> to:
      </p>
      <ul>
        <li>Use the App for any commercial or business purposes.</li>
        <li>Copy, modify, or create derivative works of the App.</li>
        <li>
          Reverse engineer, decompile, or attempt to extract the source code of
          the App.
        </li>
        <li>Sell, rent, lease, sublicense, distribute, or transfer the App.</li>
        <li>
          Use the App in any unlawful manner or in violation of any applicable
          laws.
        </li>
      </ul>
    </LegalSection>

    <LegalSection>
      <h3>3. Intellectual Property Rights</h3>
      <p>
        All rights, title, and interest in and to the App, including all
        intellectual property rights, are owned by the Company. This Agreement
        does not grant you any rights to trademarks or service marks of the
        Company.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>4. Privacy and Data Collection</h3>
      <p>
        We may collect certain technical data and related information about your
        device and software to facilitate updates and improvements. Please refer
        to our <a href="/privacy">Privacy Policy</a> for details on how we
        collect and use information.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>5. Disclaimer of Warranties</h3>
      <p>
        The App is provided "as is" and "as available" without warranties of any
        kind. We disclaim all warranties, express or implied, including but not
        limited to warranties of merchantability, fitness for a particular
        purpose, and non-infringement.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>6. Limitation of Liability</h3>
      <p>
        To the maximum extent permitted by law, the Company shall not be liable
        for any indirect, incidental, special, consequential, or punitive
        damages arising out of your use or inability to use the App. Our total
        liability shall not exceed the amount you paid for the App, if any.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>7. Indemnification</h3>
      <p>
        You agree to indemnify and hold harmless the Company, its affiliates, and
        their officers, directors, employees, and agents from any claims or
        liabilities arising out of your misuse of the App or violation of this
        Agreement.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>8. Termination</h3>
      <p>
        This Agreement is effective until terminated. Your rights under this
        Agreement will terminate automatically if you fail to comply with any
        term. Upon termination, you must cease all use of the App and delete all
        copies.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>9. Governing Law</h3>
      <p>
        This Agreement shall be governed by and construed in accordance with the
        laws of the Province of Ontario, Canada, and the federal laws of Canada
        applicable therein, without regard to conflict of law principles.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>10. Severability</h3>
      <p>
        If any provision of this Agreement is held invalid, the remaining
        provisions shall continue in full force and effect.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>11. Entire Agreement</h3>
      <p>
        This Agreement constitutes the entire agreement between you and the
        Company regarding the App and supersedes all prior agreements.
      </p>
    </LegalSection>

    <LegalSection>
      <h3>12. Contact Information</h3>
      <p>For questions about this Agreement, please contact us at:</p>
      <p>
        15156215 Canada Inc.
        <br />
        Doing business as Apperytime
        <br />
        Email: <a href="mailto:support@lastseen.app">support@lastseen.app</a>
      </p>
    </LegalSection>
  </LegalPage>
)

export default Eula
